module.exports = __webpack_public_path__ + "modules/services/images/pro_4.png?7abcdf87";


//////////////////
// WEBPACK FOOTER
// ./modules/services/images/pro_4.png
// module id = 173
// module chunks = 0